import React, { useEffect, useState } from 'react';
import { Typography, Container, Button, IconButton, CircularProgress, Grid, Paper, Toolbar } from '@material-ui/core'
import { List, ListItem, ListItemAvatar, ListItemText, Link } from '@material-ui/core';
import PlayCircleFilledIcon from '@material-ui/icons/PlayCircleFilled';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import { withStyles } from '@material-ui/core/styles';
import { FormattedMessage  } from 'react-intl'
import MaterialTable from 'material-table';
import { bindActionCreators } from 'redux';
import { useDispatch, useSelector } from "react-redux";
import { IdentityActions, NoticeActions, NotificationActions } from '../../../store';
//import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';

const style = theme => ({
    root: {
        height: '100%'
    },
    table: {
        align: 'center'
    },
    date: {
        width: '100px',
        height: '50px',
        marginTop: '12px',
        fontSize: '18px',
        color: 'gray',
    },
    title: {
        width: 'calc(100%-100px)',
        height: '50px',
        margin: '10px',
        fontSize: '25px'
    },
    detail: {
        marginTop: '-25px',
    },
    noticeList: {
        padding: theme.spacing(1),
        marginBottom: theme.spacing(1),
        borderLeft: '6px solid #47a9de',
        backgroundColor: 'rgb(255, 255, 255)',
    },
    rightButton: {
        background: '#47A9DE',
        padding: '8px 20px',
        color: '#fff',
        border: '0px',
//        pointerEvents: 'none',
        fontSize: '16px',
    },
    loadingBackground: theme.loadingBackground,
    loading: theme.loading
})

const noticeSelector = (state) => state.Notices;
const IdentitySelector = (state) => state.Identity;

const NoticeList = (props) => {

    // useDispatch で store に紐付いた dispatch を取得。
    const dispatch = useDispatch();
    const noticeActions = bindActionCreators(NoticeActions, dispatch);
    const notificationActions = bindActionCreators(NotificationActions, dispatch);

    // useSelector で store の state を取得。
    const { list, nowWainting } = useSelector(noticeSelector);
    const { token, userData } = useSelector(IdentitySelector);

    const { classes } = props;

    /**
     *
     * Similar to componentDidMount and componentDidUpdate:
     * 
     * 第2引数に[]を渡すとマウント時のみ呼び出される
     */
    useEffect(() => {

        if (props.refresh == null || props.refresh == true) {
            // storeにアカウントリストを要求
            noticeActions.listNotices(token)
                .then(data => {
                })
                .catch(e => {
                    notificationActions.showError(e.message);
                });
        }

    }, []);

    /**
     * 
     * 詳細ボタン押下時の処理
     * 
     * @param data 選択された行のデータ 
     */
    const onDetailClick = (data) => {
        props.onDetail(data);
    }

//    const placeholder = <FormattedMessage id="Table.Action" />;

    return (
        <Container className={classes.root} maxWidth={false}>
            <Paper className={classes.paper}>
                <Toolbar variant="regular">
                    <div>
                        <Typography component="h1" variant="inherit"><FormattedMessage id="Notice.Title" /></Typography>
                    </div>
                </Toolbar>
            </Paper>
            <Grid>
                <Grid item xs={12} md={12}>
                    <div>
                        <List>
                            {list.map((x) => {
                                return (
                                    <ListItem className={classes.noticeList}>
                                        <ListItemAvatar>
                                            <PlayCircleFilledIcon />
                                        </ListItemAvatar>
                                        <ListItemText>
                                            <Link onClick={() => onDetailClick(x)} color="inherit">
                                                {x.title}
                                            </Link>
                                        </ListItemText>
                                        <Button variant="contained" className={classes.rightButton} onClick={() => onDetailClick(x)}>
                                            {x.date.substring(0, 10)}
                                        </Button>
                                    </ListItem>
                                )
                            })}
                        </List>
                    </div>
                </Grid>
            </Grid>

            {(nowWainting) && <div className={classes.loadingBackground}><div className={classes.loading}><CircularProgress /></div></div>}

        </Container>
    )
}

export default withStyles(style, { withTheme: true })(NoticeList);
